<template>

<v-dialog v-model="show"
	:id="'delete-order-modal-' + parsedOrder.orderHash"
	max-width="500" persistent :fullscreen="fullscreen"
>
	<v-card>

		<!--Modal Title -->
		<v-toolbar flat v-bind:class="{'green lighten-3': !$vuetify.theme.dark, 'grey darken-2': $vuetify.theme.dark }">
			<v-toolbar-title>{{ $t('common.phrase.deleteOrderRecord') }}</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn icon @click="show = false">
				<v-icon>mdi-window-close</v-icon>
			</v-btn>
		</v-toolbar>

		<!-- Modal Contents -->
		<v-card-text class="pa-5">

			<div class="mb-2">
				{{ $t('compOrderSummary.deleteOrder.areYouSure') }}
			</div>

			<div class="text-center my-3">
				<v-btn v-show="!deleteOrderStatus.loading" outlined @click="hideModal()" :disabled="deleteOrderStatus.loading" class="mr-3">
					{{ $t('compOrderSummary.deleteOrder.doNotDelete') }}
				</v-btn>
				<v-btn color="error" @click="deleteOrderRecord()" :disabled="deleteOrderStatus.loading">
					{{ $t('compOrderSummary.deleteOrder.yesDelete') }}
					<ButtonLoading v-show="deleteOrderStatus.loading" class="ml-3" />
				</v-btn>
			</div>

		</v-card-text>

		<v-card-actions v-if="fullscreen">
			<v-spacer></v-spacer>
			<v-btn color="primary" outlined text class="mr-3" @click="show = false">
				<v-icon>mdi-window-close</v-icon> {{ $t('common.verb.close')}}
			</v-btn>
		</v-card-actions>

	</v-card>
</v-dialog>

</template>

<script>
import { config } from '@/config'
import {mapActions, mapGetters, mapState} from 'vuex'
import Preloader from "@/components/Preloader"
import ButtonLoading from "@/components/ButtonLoading"

export default {
	name: 'DeleteOrderModal',
	components: {
		Preloader,
		ButtonLoading,
	},
	props: {
		parsedOrder: { type: Object },
		fullscreen: { type: Boolean, default: false},
	},
	data () {
		return {
			config: config,
			show: false,
			deleteOrderStatus: {
				loading: false,
			},
		}
	},
	computed: {
		...mapGetters({
			network: 'getNetwork',
			account: 'getAccount',
			tokenInfo: 'getTokenInfo',
			myAddress: 'getUserAccount',
			networkConfig: 'getNetworkConfig',
			web3Wrapper: 'getWeb3Wrapper',
			providerEngine: 'getProviderEngine',
			contractWrappers: 'getContractWrappers',
			contractAddresses: 'getContractAddresses',
		}),
	},
	methods: {
		...mapActions(['loadNetwork', 'loadTokenInfo', 'loadAccount']),

		/* ------------------------------------------------------ */
		// async init () {
		//   // console.log('UnwrapETH init')
		//   this.initializationDone = false
		//   if (this.networkNeedReload) {
		//     await this.loadNetwork()
		//   }
		//   if (this.tokenInfoNeedReload) {
		//     await this.loadTokenInfo()
		//   }
		//   if (this.accountNeedReload) {
		//     await this.loadAccount()
		//   }
		//   this.initializationDone = true
		// },
		showModal () {
			this.show = true
		},
		hideModal () {
			this.show = false
		},
		async deleteOrderRecord () {
			const orderHash = this.parsedOrder.orderHash
			if (!orderHash) {
				throw new Error("Missing Order ID")
			}

			this.deleteOrderStatus.loading = true

			const apiURL = `${this.config.backendAPIURL}/${this.network.id}/order/${orderHash}`

			try {
				await this.$http.delete(apiURL)
				this.emitSuccess(orderHash)
			} catch (err) {
				console.log(err)
			} finally {
				this.deleteOrderStatus.loading = false
				this.hideModal()
			}

		},
		emitSuccess (orderHash) {
			this.$emit('delete-order-complete', orderHash)
		}
	},
	created () {
	},
	beforeDestroy () {
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
